import { styled } from 'styled-components'

const ButtonContainerSkeleton = styled.div`
  padding: 1rem 1.25rem;
`

const SignalContainerSkeleton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 12px;
`

export { ButtonContainerSkeleton, SignalContainerSkeleton }
